import React from "react";
import moment from "moment";
import { useIsMobile } from "../../hooks/useIsMobile";

interface IFormatDateOptions { withDate?: boolean; withTime?: boolean; isShortDate?: boolean; }

export const formatDate = (date: moment.MomentInput, { withDate = true, withTime = false, isShortDate = false }: IFormatDateOptions) =>
  moment(date).format(
    (withDate ? (isShortDate ? 'll' : 'LL') : "") + (withTime ? " LT" : "")
  ).trim();

interface IFormattedDateProps extends IFormatDateOptions {
  date: moment.MomentInput
}

export const FormattedDate = (props: IFormattedDateProps) => {
  const isMobile = useIsMobile()
  return (
    <span>
      {formatDate(props.date, { ...props, isShortDate: isMobile })}
    </span>
  )
}
